export const GET_ALL_ROUNDS = "GET_ALL_ROUNDS";
export const DELETE_ROUND = "DELETE_ROUND";
export const ADD_ROUND = "ADD_ROUND";
export const EDIT_ROUND = "EDIT_ROUND";
export const GET_ROUND_STATUSES = "GET_ROUND_STATUSES";
export const CLOSE_ACTIVE_ROUND = "CLOSE_ACTIVE_ROUND";
export const MAKE_CHANGES = "MAKE_CHANGES";
export const MAKE_PROFITS = "MAKE_PROFITS";
export const GET_SETTINGS = "GET_SETTINGS"
export const MAKE_COPY = "MAKE_COPY";